import React from 'react';
import PropTypes from 'prop-types';

export default function FoldersIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
      className={className}
    >
      <g id='Grupo_151520' data-name='Grupo 151520' transform='translate(-551 -1393)'>
        <rect
          id='Canvas'
          width={width}
          height={height}
          transform='translate(551 1393)'
          opacity='0'
        />
        <path
          id='Subtração_1'
          data-name='Subtração 1'
          d='M-823.5-194h-15a.5.5,0,0,1-.5-.5V-206a1,1,0,0,1,1-1h4.965a1.009,1.009,0,0,1,.716.3l1.652,1.7h7.166a.5.5,0,0,1,.5.5v10A.5.5,0,0,1-823.5-194Zm-9.994-6.746a.5.5,0,0,0-.354.146.5.5,0,0,0-.147.354.5.5,0,0,0,.147.354l2.495,2.494a.494.494,0,0,0,.354.147.493.493,0,0,0,.353-.147l2.5-2.494a.5.5,0,0,0,.148-.354.5.5,0,0,0-.308-.463.5.5,0,0,0-.192-.038.5.5,0,0,0-.353.146L-831-198.458l-2.141-2.142A.5.5,0,0,0-833.494-200.747ZM-838-206v2h6.908l-1.942-2H-838Z'
          transform='translate(1391 1602)'
          fill={fill}
        />
      </g>
    </svg>
  );
}

FoldersIcon.defaultProps = {
  fill: '#41a152',
  width: 18,
  height: 18
};

FoldersIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
